<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})">Definicje faktur</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})">{{ facture.id }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Nowa pozycja
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

          <multiselect-input v-model="form.cycle" :error="form.errors.cycle" label="Cykl" :options="cycles" class="pr-6 pb-8 w-full lg:w-1/2" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" :searchable="false" />

          <text-input v-model="form.cycle_from" :error="form.errors.cycle_from" class="pr-6 pb-8 w-full lg:w-1/2" label="Data wystawienia" type="date" />

          <multiselect-input v-model="form.article" :error="form.errors.article" label="Artykuł" :options="articles" class="pr-6 pb-8 w-full lg:w-1/2" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" :searchable="false" @input="onSelectArticle" />

          <text-input v-model="form.ilosc" :error="form.errors.ilosc" class="pr-6 pb-8 w-full lg:w-1/2" label="Ilość" type="number" min="1" max="100" />


          <template v-if="form.article != null">
            <text-input v-model="form.cena_netto" :error="form.errors.cena_netto" class="pr-6 pb-8 w-full lg:w-1/3" label="Cena netto" type="number" step="0.01" />
            <text-input v-model="form.vat_sprzedazy" :error="form.errors.vat_sprzedazy" class="pr-6 pb-8 w-full lg:w-1/3" label="Vat [%]" type="number" />
            <text-input v-model="form.cena_brutto" :error="form.errors.cena_brutto" class="pr-6 pb-8 w-full lg:w-1/3" label="Cena brutto" type="number" step="0.01" />
          </template>
          

          <shtax-text-area-input class="pr-6 pb-8 w-full" v-model:checked="form.notice" :error="form.errors.notice" label="Opis na pozycji" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-shtax" type="submit">Dodaj pozycję</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import ShtaxTextAreaInput from '@/ShtaxComponents/TextAreaInput'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Nowa pozycja dla faktury' },
  components: {
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    ShtaxTextAreaInput,
    MultiselectInput
  },
  layout: Layout,
  props: {
    config: Object,
    facture: Object,
    articles: Array,
    cycles: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        cycle: this.cycles.find(cycle => cycle.default),
        cycle_from: null,
        article: this.config.artykul,
        ilosc: this.config.ilosc,
        cena_netto: this.facture.netto,
        cena_brutto: this.facture.brutto,
        vat_sprzedazy: this.config.vat,
        notice: this.config.opis
      })
    }
  },
  methods: {
    store() {
      this.form.post(this.route('factures.positions.store', this.facture.id))
    },

    onSelectArticle() {
      this.form.cena_netto = this.form.article.cena_detal.CENA_NETTO
      this.form.cena_brutto = this.form.article.cena_detal.CENA_BRUTTO
      this.form.vat_sprzedazy = this.form.article.VAT_SPRZEDAZY.trim()
    }
  },

  computed: {
    cena_netto() {
      return this.form.cena_netto 
    },

    cena_brutto() {
      return this.form.cena_brutto 
    }
  },

  watch: {
    cena_netto() {
      this.form.cena_brutto = Math.round(this.form.cena_netto*(1.0+(this.form.vat_sprzedazy/100.0)) * 100) /100 +''
    },
    cena_brutto() {
      this.form.cena_netto = Math.round(this.form.cena_brutto/(1.0+(this.form.vat_sprzedazy/100.0)) * 100) /100 +''
    }
  },

  mounted() {
    let today = new Date()

    if (today.getDate() < 20)
      this.form.cycle_from = today.getFullYear() +'-'+ (today.getMonth()< 9 ? ('0' +(today.getMonth() +1)) : (today.getMonth() +1)) +'-20';
    else
      this.form.cycle_from = today.getFullYear() +'-'+ (today.getMonth()< 8 ? ('0' +(today.getMonth() +2)) : (today.getMonth() +2)) +'-20';
  }
}
</script>
